<!-- 物流公司详情 -->
<template>
  <div class="company-list flex-column">
		<Title :iconBack="true"/>
		<div class="flex-column-1 none-collect" v-show="!companysData.join(',')">
			<div class="none-data">暂无收藏</div>
		</div>
		<div v-show="companysData.join(',')" class="list-detail flex-column-1" :style="{'-webkit-overflow-scrolling': scrollMode}">
			<v-loadmore id="ZXLB" :auto-fill="false" ref="loadMore" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded">
				<ul class="all-company">
					<!-- 这里多加了个index作为参数 正式的时候去掉 尽量用id 路由参数也需要修改 -->
					<div   tag="li" @click="toDetail(company.organizationId)" v-for="(company,index) in companysData"  :key="index"  class="d-flex flex-fill company-detail-item">
						<div class="dv-pic">
							<img class="img-fluid" v-lazy="getImgUrl(company.companyLogo)" alt="">	
						</div>
						<div class="text-detail">
							<h3 class="tiles company-name">{{company.companyName}}</h3>
							<h4 class="tiles addre-name">直达线路:{{`${company.startCity}-${company.destCity}`}}</h4>
							<h5 class="tiles detail-addre-name-tel">地址:{{company.companyAddr}}</h5>
							<h5 class="tiles detail-addre-name-tel">电话:{{company.servicePhoneNo}}</h5>
							<Label :companyLabels="company.companyLabel"/>
							<span class="rounded-tel" @click.stop="callNum(company.servicePhoneNo)">
								<i class="fa fa-phone"></i>
							</span>
						</div>
					</div>
				</ul>
				<div class="more_loadings">
					<span v-show="allLoaded&&companysData.length!=0">这是我的底线啦!!!</span>
				</div>
			</v-loadmore>	
		</div>   
	</div>
</template>

 <script>
 import Label from '@/components/function/label/label.vue'
 import { companys } from '@/assets/mock.data'
 import { Loadmore } from 'mint-ui'
 import { Toast } from 'mint-ui'
 import { GET_FAVORITE_ORGANIZATION } from '@/assets/configs/api/otmsApi.js'
 export default {
		components:{
			Label,
			'v-loadmore': Loadmore
		},
		data () {
			return {
				allLoaded: false,
				isLoadBottom: true,
				scrollMode:"touch",
				companysData:[],
				direction:null,
				params:{
					pages:1,
					pageSize:6,
					seachKey:"",
					startCityName:"",
					destCityName:""
				}
			}	
		},
		computed: {
			companys (){
				return companys.splice(0,10)
			}
		},
		methods : {
			getImgUrl(imgUrl){
	  		var t = new Date().getTime()
	  		return imgUrl + `?t=${t}`
	  	},
			callNum (num) {
				window.location.href = 'tel://' + num
			},
			loadBottom() {
				this.getData ()
			},
			//获取数据列表
			getData (type) {
				this.$post(GET_FAVORITE_ORGANIZATION,
					this.params,
					data => {
						this.$refs.loadMore.onBottomLoaded(this.$refs.loadMore.$el.id)
						if(data.list.length < 6){
							this.allLoaded = true
						}
						if(data.list.length != 0){
							data.list.forEach( item => {
								this.companysData.push(item)
							})
							this.params.pages += 1
						}else{
							this.allLoaded = true
						}
			        },
			        error => {
			        	
			        }
			    )
			},
			toDetail (organizationId) {
				this.$router.push({name:'collect-company-detail',query:{organizationId:organizationId}})
			}
		},
		mounted () {
			this.getData()
		}
 }
 </script>

<style scoped lang="scss">
	@import './list.scss';
</style>